import React, { useCallback } from 'react'
import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'
import { v4 as uuid4 } from 'uuid'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { VariableResultColumnData, VariableResultCurrentRow, VariableSelectFeatureFlag } from '@makyoapp/makyo-common'
import { SingleCell16 } from '@makyoapp/makyo-icon/icon'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'

import { VariableColumnDataBody } from './VariableColumnData'
import { VariableWrapper } from './VariableWrapper'

export default function VariableCurrentRow({
  id,
  onChange,
  columnTypes = Object.values(ColumnTypes),
  excludeColIds = [],
}: {
  id?: string
  onChange?: (newValue: VariableResultCurrentRow) => void
  columnTypes?: ColumnTypes[]
  excludeColIds?: string[]
}) {
  const [show, setShow] = useBoolean(false)
  const [us, setUs] = useBoolean(false)

  const { isDetailPage } = useActiveLayerContext()

  if (!isDetailPage) {
    return null
  }

  return (
    <VariableWrapper
      id={id}
      show={show}
      setShow={setShow}
      title={<Trans>{`This screen's data`}</Trans>}
      icon={<SingleCell16 width={16} height={16} />}
      defaultHeight={false}
      defaultWidth={false}
      menuClassName='min-w-[220px]'
    >
      <VariableCurrentRowBody
        value={{
          id: uuid4(),
          flag: VariableSelectFeatureFlag.CurrentRow,
          col: undefined,
          userSpecific: false,
        }}
        setShow={setShow}
        userSpecific={us}
        setUserSpecific={setUs}
        columnTypes={columnTypes}
        onChange={onChange}
        excludeColIds={excludeColIds}
      />
    </VariableWrapper>
  )
}

export function VariableCurrentRowBody({
  onChange,
  columnTypes = Object.values(ColumnTypes),
  setShow,
  value,
  userSpecific,
  setUserSpecific,
  excludeColIds = [],
}: {
  onChange?: (newValue: VariableResultCurrentRow) => void
  columnTypes?: ColumnTypes[]
  setShow: (nextShow: boolean) => void
  value: VariableResultCurrentRow
  userSpecific: boolean
  setUserSpecific: (next: boolean) => void
  excludeColIds?: string[]
}) {
  const handleChange = useCallback(
    (v: VariableResultColumnData) => {
      const val: VariableResultCurrentRow = {
        id: v.id,
        flag: VariableSelectFeatureFlag.CurrentRow,
        col: v.col,
        userSpecific: v.userSpecific,
      }
      onChange?.(val)
    },
    [onChange]
  )
  return (
    <VariableColumnDataBody
      setShow={setShow}
      userSpecific={userSpecific}
      setUserSpecific={setUserSpecific}
      columnTypes={columnTypes}
      value={value as unknown as VariableResultColumnData}
      onChange={handleChange}
      noTbl
      excludeColIds={excludeColIds}
    />
  )
}
